module.exports = __webpack_public_path__ + "img/featuredartist15 (2).ca290ff0.jpg";